import { t } from 'i18next';
import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { playerComparisonPositionsAtom } from '@/atoms/queries/player/playerComparisonPositions';
import { convertToDropdownOption } from '@/utils/object';
import { buildPositionOptions } from '../../queries/player/utils';
import { comparisonFiltersAtom } from '../comparison';

export const playerComparisonPositionsOptionsAtom = atom(async get => {
  const playerComparisonPositions = await get(playerComparisonPositionsAtom);

  const { positionOptions, otherPositions } = buildPositionOptions(playerComparisonPositions);

  return [
    ...positionOptions,
    ...(otherPositions.length > 0
      ? [{ ...convertToDropdownOption(t('other', { ns: 'filters' }), otherPositions.join(',')), other: true }]
      : []),
  ];
});

export const unwrappedPlayerComparisonPositionsOptionsAtom = unwrap(
  playerComparisonPositionsOptionsAtom,
  prev => prev || [],
);

export const comparisonSelectedPositionOptionsAtom = atom(get => {
  const positionOptions = get(unwrappedPlayerComparisonPositionsOptionsAtom);
  const comparisonSelectedPositions = get(comparisonFiltersAtom).positions;
  return positionOptions.filter(({ value }) => comparisonSelectedPositions.some(position => position === value));
});

export const comparisonSelectedPositionsFilterParamsAtom = atom(get =>
  get(comparisonFiltersAtom).positions.flatMap(id => id.split(',')),
);
